import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { daDate } from "@/lib/date";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { MonitorSmartphone, Trash2 } from "lucide-react";

export const TrustedDevicesDialog = ({ open, onOpenChange }) => {
  const [items, setItems] = useState(null);
  const load = () => api.get("/auth/trusted-devices").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { if (open) load(); }, [open]);
  const remove = async (d) => {
    try { await api.delete(`/auth/trusted-devices/${d.id}`); toast.success("Enheden er fjernet"); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-2xl sm:max-w-[520px]" data-testid="trusted-devices-dialog">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold">Betroede enheder</DialogTitle>
          <DialogDescription className="text-sm text-stone-500">Enheder, hvor du ikke skal indtaste e-mailkode ved login. Fjern dem, du ikke genkender.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2 mt-1">
          {items === null && <p className="text-sm text-stone-400">Indlæser…</p>}
          {items?.length === 0 && <p className="text-sm text-stone-400" data-testid="trusted-devices-empty">Ingen betroede enheder.</p>}
          {items?.map((d) => (
            <div key={d.id} className="flex items-center gap-3 rounded-xl border border-[#EBE8E3] bg-white px-3.5 py-3" data-testid={`trusted-device-${d.id}`}>
              <MonitorSmartphone className="h-4 w-4 text-stone-400 shrink-0" strokeWidth={1.75} />
              <div className="min-w-0 flex-1">
                <p className="text-sm font-medium text-[#1A1919] truncate">{d.label}{d.current && <span className="ml-2 text-[10px] font-semibold text-[#2E7D32] bg-[#F3F6EE] border border-[#D3D8C6] rounded-md px-1.5 py-0.5 align-middle">Denne enhed</span>}</p>
                <p className="text-xs text-stone-500">Tilføjet {daDate(d.created_at)} · senest brugt {daDate(d.last_used_at)} · udløber {daDate(d.expires_at)}</p>
              </div>
              <Button size="icon" variant="ghost" className="rounded-xl h-9 w-9 text-stone-400 hover:text-destructive hover:bg-[#F1DEDA]" onClick={() => remove(d)} data-testid={`remove-trusted-device-${d.id}`}><Trash2 className="h-3.5 w-3.5" /></Button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
